"use client";
import { React } from "react";
import TopBar from "../components/common/TopBar";
import LoginForm from "./../components/LoginForm";

const Login = () => {
  const responseFacebook = (response) => {
    console.log(response);
    if (response.accessToken) {
      // Send accessToken to backend
      fetch('/api/auth/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accessToken: response.accessToken })
      });
    }
  };

  return (
    <main className="flex flex-col items-center w-full min-h-screen bg-white">
      <TopBar />
      <section className="flex flex-col gap-6 items-start mt-64 w-[500px] max-md:mt-32 max-md:max-w-[500px] max-md:w-[100%] max-sm:mt-20 max-sm:w-[100%]">
        <h1 className="w-full text-3xl font-semibold leading-9 text-center text-gray-700 max-sm:text-2xl max-sm:leading-8">
          Welcome back!
        </h1>
        <LoginForm />
       
      </section>
    </main>
  );
};

export default Login;